import {NestedKeys} from 'shared/types/key-manipulation';
import {BaseInputProps} from '..';
import {UseFormReturn} from 'react-hook-form';
import {
  translatedProps,
  TranslationKeyProps,
} from 'shared/util/translated-props';
import getNestedKey from 'shared/util/get-nested-key';
import getSentenceGender from 'shared/util/find-sentence-gender';

const validateFormInputs = (
  inputs: (NestedKeys<any> | (() => BaseInputProps<any>))[],
  formContext: UseFormReturn<any, any>,
  translationKey: TranslationKeyProps,
) => {
  const data = formContext.getValues();

  let isError = false;
  formContext.clearErrors();
  inputs.forEach((input) => {
    if (typeof input === 'string') return;

    const {name, required, label: inputLabel} = input();

    const isInputRequired =
      typeof required === 'function' ? required(data) : required;

    if (!isInputRequired) return;

    const value = getNestedKey(data ?? {}, name!);

    if (Array.isArray(value) && value.length === 0) {
      const label =
        inputLabel ??
        getNestedKey(
          typeof translationKey !== 'string'
            ? translationKey
            : translatedProps[translationKey as keyof typeof translatedProps],
          name!,
        );

      const sentenceGender = getSentenceGender(label);

      formContext.setError(name!, {
        type: 'required',
        message: `${label} não informad${sentenceGender}`,
      });
      isError = true;
      return;
    }

    if (value !== null && value !== undefined && value !== '') return;

    const label =
      inputLabel ??
      getNestedKey(
        typeof translationKey !== 'string'
          ? translationKey
          : translatedProps[translationKey as keyof typeof translatedProps],
        name!,
      );

    const sentenceGender = getSentenceGender(label);

    formContext.setError(name!, {
      type: 'required',
      message: `${label} não informad${sentenceGender}`,
    });

    isError = true;
  });

  return isError;
};

export default validateFormInputs;
